var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage16Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:image-16-regular"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 11.004C9 11.5355 9.21114 12.0452 9.58696 12.421C9.96278 12.7969 10.4725 13.008 11.004 13.008C11.5355 13.008 12.0452 12.7969 12.421 12.421C12.7969 12.0452 13.008 11.5355 13.008 11.004C13.008 10.4725 12.7969 9.96278 12.421 9.58696C12.0452 9.21114 11.5355 9 11.004 9C10.4725 9 9.96278 9.21114 9.58696 9.58696C9.21114 9.96278 9 10.4725 9 11.004V11.004ZM28 9C28 7.67392 27.4732 6.40215 26.5355 5.46447C25.5979 4.52678 24.3261 4 23 4H9C7.67392 4 6.40215 4.52678 5.46447 5.46447C4.52678 6.40215 4 7.67392 4 9V23C4 24.3261 4.52678 25.5979 5.46447 26.5355C6.40215 27.4732 7.67392 28 9 28H23C24.3261 28 25.5979 27.4732 26.5355 26.5355C27.4732 25.5979 28 24.3261 28 23V9ZM23 6C23.7956 6 24.5587 6.31607 25.1213 6.87868C25.6839 7.44129 26 8.20435 26 9V23C26 23.464 25.896 23.9 25.708 24.294L18.404 16.99C17.7664 16.3525 16.9017 15.9943 16 15.9943C15.0983 15.9943 14.2336 16.3525 13.596 16.99L6.292 24.294C6.104 23.902 6 23.464 6 23V9C6 8.60603 6.0776 8.21593 6.22836 7.85195C6.37913 7.48797 6.6001 7.15726 6.87868 6.87868C7.15726 6.6001 7.48797 6.37913 7.85195 6.22836C8.21593 6.0776 8.60603 6 9 6H23ZM7.706 25.708L15.01 18.404C15.14 18.274 15.2943 18.1708 15.4642 18.1005C15.6341 18.0301 15.8161 17.9939 16 17.9939C16.1839 17.9939 16.3659 18.0301 16.5358 18.1005C16.7057 18.1708 16.86 18.274 16.99 18.404L24.294 25.708C23.902 25.896 23.464 26 23 26H9C8.536 26 8.1 25.894 7.706 25.708Z",
    fill: "#5B6AF1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage16Regular);
export default __webpack_public_path__ + "static/media/image-16-regular.e61c6531b90e4bf362079ef3fa237b5f.svg";
export { ForwardRef as ReactComponent };